import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withTheme } from '@ifit/themes/withTheme';

import { fireRipple } from '../../effects/ripple';
import './index.scss';

export const Button = ({
  className,
  theme,
  disabled,
  children,
  onClick,
  ripple,
  themeClass,
  ...rest
}) => {
  let buttonRef = React.createRef();

  function handleClick(evt) {
    onClick(evt);
    ripple && fireRipple(evt, buttonRef);
  }

  return (
    <button
      {...rest}
      ref={buttonRef}
      onClick={handleClick}
      className={classNames(`rc-button`, theme, themeClass, className, {
        disabled,
      })}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.oneOf(['primary']),
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onClick: PropTypes.func,
  ripple: PropTypes.bool,
  themeClass: PropTypes.string,
};

Button.defaultProps = {
  onClick: () => {},
  ripple: true,
  disabled: false,
};

export default withTheme(Button);
